import { Offcanvas, Form, Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { Display } from "react-bootstrap-icons";

interface FeatureFormProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  key: string;
  sectionId: string;
  dataType: "boolean" | "string" | "number" | "array" | "object";
  sortOrder: number;
  isActive: boolean | string;
  description?: string;
};

const AddConfigureFeature = ({ show, handleClose, data }: FeatureFormProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const [isLoading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);

  // Fetch Membership Sections
  useEffect(() => {
    WebService.getAPI({ action: "memberShipSections/list?limit=500" })
      .then((res: any) => setSections(res.data || []))
      .catch(() => setSections([]));
  }, []);

  // Load values on open
  useEffect(() => {
    if (show) {
      reset({
        title: data?.title || "",
        key: data?.key || "",
        sectionId: data?.sectionId || "",
        dataType: data?.dataType || "boolean",
        sortOrder: data?.sortOrder || 1,
        isActive: data?.isActive ?? true,
        description: data?.description || "",
      });
    } else {
      reset({});
    }
  }, [show, data, reset]);

  const onSubmit = (request: FormData) => {
    setLoading(true);

    // convert strings to proper boolean
    request.isActive = request.isActive === "true" || request.isActive === true;

    const apiCall = data?._id
      ? WebService.putAPI({
        action: `memberShipBenifits/update/${data._id}`,
        body: request,
      })
      : WebService.postAPI({
        action: `memberShipBenifits/add`,
        body: request,
      });

    apiCall
      .then((res: any) => {
        toast.success(res.message);
        reset();
        handleClose();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message || "An error occurred");
      });
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        reset();
        handleClose();
      }}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {data ? "Edit Benefits" : "Add Benefits"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              Benefit Details
            </span>

            {/* Title */}
            <Form.Group className="mb-2">
              <Form.Label>
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                {...register("title", { required: "Title is required" })}
                placeholder="Enter title"
              />
              {errors.title && (
                <div className="error-message">{errors.title.message}</div>
              )}
            </Form.Group>

            {/* Key */}
            {/* <Form.Group className="mb-2">
              <Form.Label>
                Key <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                {...register("key", { required: "Key is required" })}
                placeholder="Enter key"
              />
              {errors.key && (
                <div className="error-message">{errors.key.message}</div>
              )}
            </Form.Group> */}

            {/* Sections Dropdown */}
            <Form.Group
              className="mb-2"
              style={{ display: data?._id ? "none" : "block" }}
            >
              <Form.Label>
                Section <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                {...register("sectionId", { required: "Section is required" })}
              >
                <option value="">Select Section</option>
                {sections.map((item: any) => (
                  <option key={item._id} value={item._id}>
                    {item.title}
                  </option>
                ))}
              </Form.Select>
              {errors.sectionId && (
                <div className="error-message">{errors.sectionId.message}</div>
              )}
            </Form.Group>

            {/* DataType (Matches backend enum) */}
            {/* <Form.Group className="mb-2">
              <Form.Label>
                Data Type <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                {...register("dataType", { required: "Data type is required" })}
              >
                <option value="boolean">Boolean</option>
                <option value="string">String</option>
                <option value="number">Number</option>
                <option value="array">Array</option>
                <option value="object">Object</option>
              </Form.Select>
            </Form.Group> */}

            {/* Sort Order */}
            {/* <Form.Group className="mb-2">
              <Form.Label>
                Sort Order <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                {...register("sortOrder", { required: "Sort order is required" })}
              />
            </Form.Group> */}

            {/* Status */}
            <Form.Group className="mb-2">
              <Form.Label>Status</Form.Label>
              <Form.Select {...register("isActive")}>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </Form.Select>
            </Form.Group>

            {/* Description */}
            <Form.Group className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" {...register("description")} />
            </Form.Group>
          </Card>
        </Form>
      </Offcanvas.Body>

      <div className="p-3">
        <CustomButton
          isLoading={isLoading}
          label="Save"
          className="w-100"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </Offcanvas>
  );
};

export default AddConfigureFeature;
